import { AxiosInstance } from "axios";
import { Update } from "../../components/Insights";
import { ControlType } from "../../types/controlsRisk";

export const updateRiskTheme = async (
  axiosInstance: AxiosInstance,
  data: any
) => {
  return await axiosInstance.patch(`/rest/risk/v1/update`, data);
};

export const updateControl = async (
  axiosInstance: AxiosInstance,
  data: ControlType
) => {
  return await axiosInstance.patch(`/rest/risk-item/v1/update`, data);
};

export const postCreateRisk = async (
  axiosInstance: AxiosInstance,
  data: any
) => {
  return await axiosInstance.put(`/rest/risk/v1/create`, data);
};

export const putCreateControl = async (
  axiosInstance: AxiosInstance,
  data: any
) => {
  return await axiosInstance.put(
    `/rest/risk-item/v1/create/${data.risk_id}`,
    data.results
  );
};

export const updateHistoryControl = async (
  axiosInstance: AxiosInstance,
  data: any
) => {
  return await axiosInstance.patch(`/rest/risk-item-evolution/v1/update`, data);
};

export const updateUpdate = async (axios: AxiosInstance, body: Update) => {
  return await axios.patch("/rest/risk-update/", body);
};

export const updateViewerTags = async (
  axiosInstance: AxiosInstance,
  collaboratorId: number,
  tagIds: number[]
) => {
  return await axiosInstance
    .put(`/rest/collaborators/${collaboratorId}/tags/viewer`, tagIds)
    .then(response => response.data);
};

export const updateAdminTags = async (
  axiosInstance: AxiosInstance,
  collaboratorId: number,
  tagIds: number[]
) => {
  return await axiosInstance
    .put(`/rest/collaborators/${collaboratorId}/tags/admin`, tagIds)
    .then(response => response.data);
};
